<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/192nnbM/tc-custom/9781452125077.jpg?1737755769475" alt="This image is the cover for the book Macaroni & Cheese"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Macaroni & Cheese
      </h1>
      <p class="bookDescription body article font2">
        <b>“Sure to please even the most dedicated mac and cheese purist, while delighting anyone with a soft spot for comfort food.” —<i>Publishers Weekly</i></b><br/><br/>From the three-time James Beard Award nominee and author of <i>Grilled Cheese</i>, this cookbook puts a variety of delicious spins on the kid-friendly favorite. More than fifty recipes range from the tried-and-true Yankee Doodle Dandy Baked Macaroni and Cheese and quick-to-prepare specialties such as the yodel-worthy Alpine Macaroni with Appenzeller and Crème Fraiche to international specialties like Giuvetchi, a Greek dish of orzo in a cinnamon tomato sauce with lamb and kasseri, myzithra, and feta cheeses. There are even a few dessert versions like Falooda, a traditional Indian treat, this one using ricotta and sweet vermicelli, with cherries and a touch of cardamom. <br/><br/>Recipes for side salads and soups help round out a balanced meal. Mac &amp; cheese—it’ll always please!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marlena Spieler, Noel Barnhurst
      </h2>
      
      <p class="authorDescription body article">Marlena Spieler is the author of over 50 cookbooks published worldwide, including Grilled Cheese, and has written for Bon Appétit and Saveur. She writes the San Francisco Chronicle award-winning food column "The Roving Feast" and is a three-time James Beard nominee. Born in Sacramento, California, she lives in Hampshire, England. Noel Barnhurst is a San Francisco–based photographer whose work has appeared in Bon Appétit and Fine Cooking.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f4b7794